interface HeaderBackgroundProps {
  className?: string;
  blur?: number;
  opacity?: number;
}

/**
 * Reusable header background component with twilight video
 * Uses opacity for visual depth and parallax effect
 * Can be used across all header components for consistent styling
 */
export default function HeaderBackground({
  className = '',
  blur = 30,
  opacity = 0.3
}: HeaderBackgroundProps) {
  return (
    <div
      className={`absolute ${className}`}
      style={{
        top: `-${blur * 2}px`,
        left: `-${blur * 2}px`,
        right: `-${blur * 2}px`,
        bottom: `-${blur * 2}px`,
        overflow: 'hidden'
      }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: opacity,
          filter: blur > 0 ? `blur(${blur}px)` : 'none'
        }}
        src="/videos/twilight.mp4"
      />
    </div>
  );
}
